import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { apiUrl, getErrorMessage } from '../utils/api';

function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const passwordStrength = (() => {
    const value = password || '';
    let score = 0;
    if (value.length >= 8) score += 1;
    if (/[A-Z]/.test(value)) score += 1;
    if (/[0-9]/.test(value)) score += 1;
    if (/[^A-Za-z0-9]/.test(value)) score += 1;
    const labels = ['Very weak', 'Weak', 'Fair', 'Good', 'Strong'];
    return {
      score,
      label: labels[Math.min(score, labels.length - 1)],
      width: `${Math.max(12, score * 25)}%`,
      tone: score >= 4 ? 'strong' : score >= 3 ? 'good' : score >= 2 ? 'fair' : 'weak',
    };
  })();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setBusy(true);
    try {
      const { data } = await axios.put(apiUrl(`/api/auth/password/reset/${token}`), { password });
      localStorage.setItem('userInfo', JSON.stringify(data));
      window.dispatchEvent(new Event('authchange'));
      navigate('/dashboard');
    } catch (err) {
      setError(getErrorMessage(err, 'Could not reset your password. The link may have expired.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page auth-page">
      <form className="panel auth-card" onSubmit={handleSubmit}>
        <p className="eyebrow">Account security</p>
        <h1>Set a new password</h1>
        <p className="muted-text">Choose a new password for your account.</p>
        <input type="password" placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <div className="password-strength">
          <div className="password-strength-row">
            <span>Password strength</span>
            <strong>{passwordStrength.label}</strong>
          </div>
          <div className="password-strength-bar">
            <span className={`password-strength-fill ${passwordStrength.tone}`} style={{ width: passwordStrength.width }} />
          </div>
        </div>
        <input type="password" placeholder="Confirm new password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
        <button type="submit" disabled={busy}>{busy ? 'Updating…' : 'Reset password'}</button>
        {error && <p className="error-message">{error}</p>}
        <p className="muted-text"><Link to="/login">Back to login</Link></p>
      </form>
    </div>
  );
}

export default ResetPassword;
